export default {
  'vip.exchange.title': 'Configuración de Intercambio de Valor de Crecimiento VIP',
  'vip.exchange.ruleTitle': 'Descripción de Reglas VIP',
  'vip.exchange.currency': 'Moneda',
  'vip.exchange.amount': 'Monto',
  'vip.exchange.growthValue': 'Valor de Crecimiento VIP',
  'vip.exchange.enterAmount': 'Ingrese el monto',
  'vip.exchange.enterGrowthValue': 'Ingrese el valor de crecimiento',
  'vip.exchange.enterValidNumber': 'Ingrese un número válido (hasta 2 decimales)',
  'vip.exchange.enterPositiveInteger': 'Ingrese un entero positivo',
  'vip.exchange.refresh': 'Actualizar',
  'vip.exchange.save': 'Guardar',
  'vip.exchange.saveSuccess': 'Guardado exitosamente',
  'vip.exchange.saveFailed': 'Falló al guardar, verifique los datos',
  'vip.exchange.dataLoadFailed': 'Falló la carga de datos',
  'vip.exchange.ruleContent': 'Ingrese la descripción de las reglas VIP',
  'vip.exchange.ruleContentRequired': 'Ingrese la descripción de las reglas VIP',
  'vip.log.grow.title': 'Registros de Valor de Crecimiento VIP',
  'vip.log.level.title': 'Registros de Cambio VIP',
  'vip.log.memberAccount': 'Cuenta de Miembro',
  'vip.log.level': 'Nivel VIP',
  'vip.log.changeReason': 'Razón del Cambio',
  'vip.log.beforeGrow': 'Valor de Crecimiento VIP Antes del Cambio',
  'vip.log.grow': 'Cambio de Valor de Crecimiento VIP',
  'vip.log.afterGrow': 'Valor de Crecimiento VIP Después del Cambio',
  'vip.log.createTime': 'Fecha de Creación',
  'vip.log.changeTime': 'Fecha de Cambio',
  'vip.log.changeType': 'Tipo de Cambio',
  'vip.log.beforeLevel': 'Antes del Cambio',
  'vip.log.afterLevel': 'Después del Cambio',
  'vip.log.operator': 'Operador',
  'vip.log.upgrade': 'Ascenso',
  'vip.log.downgrade': 'Descenso',
  'vip.log.enterMemberAccount': 'Ingrese la cuenta de miembro',
  'vip.log.selectChangeType': 'Seleccione el tipo de cambio',
  'vip.setup.condition.title': 'Configuración de Condiciones VIP',
  'vip.setup.unifiedReward.title': 'Configuración de Recompensa Unificada VIP',
  'vip.setup.reward.title': 'Configuración de Recompensas VIP',
  'vip.setup.point.title': 'Configuración de Puntos VIP',
  'vip.setup.withdrawLimit.title': 'Configuración de Límite de Retiro VIP',
  'vip.setup.upgradeReward': 'Recompensa de Ascenso',
  'vip.setup.flowMultiple': 'Múltiple de Apuestas',
  'vip.setup.retentionReward': 'Recompensa de Retención',
  'vip.setup.weeklySalary': 'Salario Semanal',
  'vip.setup.weeklyRequiresDeposit': 'Depósito Requerido',
  'vip.setup.weeklyRequiresBetflow': 'Apuestas Requeridas',
  'vip.setup.monthlySalary': 'Salario Mensual',
  'vip.setup.monthlyRequiresDeposit': 'Depósito Requerido',
  'vip.setup.monthlyRequiresBetflow': 'Apuestas Requeridas',
  'vip.setup.birthdayReward': 'Recompensa de Cumpleaños',
  'vip.setup.claimValidityDays': 'Días de Validez del Reclamo',
  'vip.setup.enterUpgradeReward': 'Ingrese la recompensa de ascenso',
  'vip.setup.enterFlowMultiple': 'Ingrese el múltiple de apuestas',
  'vip.setup.enterRetentionReward': 'Ingrese la recompensa de retención',
  'vip.setup.enterWeeklySalary': 'Ingrese el salario semanal',
  'vip.setup.enterWeeklyRequiresDeposit': 'Ingrese el depósito requerido',
  'vip.setup.enterWeeklyRequiresBetflow': 'Ingrese las apuestas requeridas',
  'vip.setup.enterMonthlySalary': 'Ingrese el salario mensual',
  'vip.setup.enterMonthlyRequiresDeposit': 'Ingrese el depósito requerido',
  'vip.setup.enterMonthlyRequiresBetflow': 'Ingrese las apuestas requeridas',
  'vip.setup.enterBirthdayReward': 'Ingrese la recompensa de cumpleaños',
  'vip.setup.enterClaimValidityDays': 'Ingrese los días de validez del reclamo',
  'vip.setup.upgradePoint': 'Puntos de Ascenso',
  'vip.setup.retentionPoint': 'Puntos de Retención',
  'vip.setup.appDayPoint': 'Puntos Diarios de App',
  'vip.setup.h5DayPoint': 'Puntos Diarios H5',
  'vip.setup.verifyMobile': 'Verificación Móvil',
  'vip.setup.enterUpgradePoint': 'Ingrese los puntos de ascenso',
  'vip.setup.enterRetentionPoint': 'Ingrese los puntos de retención',
  'vip.setup.enterAppDayPoint': 'Ingrese los puntos diarios de app',
  'vip.setup.enterH5DayPoint': 'Ingrese los puntos diarios H5',
  'vip.setup.upgradeGrow': 'Valor de Crecimiento de Ascenso ≥',
  'vip.setup.retentionGrow': 'Valor de Crecimiento de Retención ≥',
  'vip.setup.retentionDays': 'Días de Validez de Retención',
  'vip.setup.unlimited': 'Permanente',
  'vip.setup.enterUpgradeGrow': 'Ingrese el valor de crecimiento de ascenso',
  'vip.setup.enterRetentionGrow': 'Ingrese el valor de crecimiento de retención',
  'vip.setup.enterRetentionDays': 'Ingrese los días de validez de retención',
  'vip.exchange.pageSubtitle': 'Configure la proporción de intercambio de valor de crecimiento para depósito y apuestas válidas por moneda, con control independiente de cambio',
  'vip.exchange.depositChannel': 'Canal de Intercambio de Depósito',
  'vip.exchange.depositChannelDesc': 'Conversión en tiempo real al depositar',
  'vip.exchange.betflowChannel': 'Canal de Intercambio de Apuestas',
  'vip.exchange.betflowChannelDesc': 'Activación de página + conversión asincrónica por sondeo',
  'vip.exchange.enabled': 'Habilitado',
  'vip.exchange.disabled': 'Deshabilitado',
  'vip.exchange.depositAmount': 'Monto de Depósito',
  'vip.exchange.depositGrowthValue': 'Valor de Crecimiento VIP',
  'vip.exchange.betflowAmount': 'Monto de Apuestas Válidas',
  'vip.exchange.betflowGrowthValue': 'Valor de Crecimiento VIP',
  'vip.exchange.description': 'Descripción',
  'vip.exchange.enterBetflowAmount': 'Ingrese el monto de apuestas válidas',
  'vip.exchange.enterBetflowGrowthValue': 'Ingrese el valor de crecimiento de apuestas',
  'vip.exchange.descDeposit': 'Cada {{amount}} {{currency}} de depósito = {{grow}} valor de crecimiento',
  'vip.exchange.descBetflow': 'Cada {{amount}} {{currency}} de apuestas válidas = {{grow}} valor de crecimiento',
  'vip.exchange.previewSaveData': 'Vista previa de datos a guardar',
  'vip.exchange.formValidationFailed': 'Falló la validación del formulario',
  'vip.setup.level': 'Nivel VIP',
  'vip.setup.upgradeGrowValidation': 'El valor de crecimiento de ascenso de VIP{currentLevel} ({currentValue}) debe ser mayor que el valor de crecimiento de ascenso de VIP{prevLevel} ({prevValue})',
  'vip.setup.retentionGrowValidation': 'El valor de crecimiento de retención de VIP{currentLevel} ({currentValue}) debe ser mayor que el valor de crecimiento de retención de VIP{prevLevel} ({prevValue})',
  'vip.log.memberAccountRequired': 'La cuenta de miembro no puede estar vacía',
  'vip.log.dataLoadFailed': 'Falló la carga de datos',
  'vip.withdrawLimit.dailyLimit': 'Límite de Retiro Diario',
  'vip.withdrawLimit.enterWithdrawLimit': 'Ingrese el límite de retiro',
  'vip.withdrawLimit.enterValidAmount': 'Ingrese un monto válido (decimal o -1 para ilimitado)',
  'vip.withdrawLimit.unlimited': 'Ilimitado',
  'vip.withdrawLimit.unlimitedHint': '-1=Ilimitado',
  'vip.withdrawLimit.enableVipWithdraw': 'Habilitar Límite VIP',
  'vip.setup.ticket.title': 'Configuración de Tickets VIP',
  'vip.setup.ticket.upgradeQuantity': 'Cantidad de Tickets',
  'vip.setup.ticket.enterTicketNumber': 'Ingrese la cantidad de tickets',
  'vip.setup.ticket.enterValidTicketNumber': 'Ingrese una cantidad válida de tickets (decimal o -1 para ilimitado)',
  'vip.setup.ticket.unlimitedHint': '-1=Ilimitado',
  'vip.setup.ticket.upgradeTicket': 'Recompensa de Ascenso VIP',
  'vip.setup.ticket.selectUpgradeTicket': 'Seleccione la recompensa de ascenso',
  'vip.setup.pointConfig.title': 'Configuración de Puntos',
  'vip.setup.pointConfig.minPoint': 'Puntos Mín.',
  'vip.setup.pointConfig.maxPoint': 'Puntos Máx.',
  'vip.setup.pointConfig.probability': 'Probabilidad',
  'vip.setup.pointConfig.add': 'Añadir',
  'vip.setup.pointConfig.delete': 'Eliminar',
  'vip.setup.pointConfig.save': 'Confirmar',
  'vip.setup.pointConfig.cancel': 'Cancelar',
  'vip.setup.pointConfig.minPointRequired': 'Ingrese los puntos mínimos',
  'vip.setup.pointConfig.maxPointRequired': 'Ingrese los puntos máximos',
  'vip.setup.pointConfig.probabilityRequired': 'Ingrese la probabilidad',
  'vip.setup.pointConfig.minPointInvalid': 'Los puntos mínimos deben ser un entero positivo',
  'vip.setup.pointConfig.maxPointInvalid': 'Los puntos máximos deben ser un entero positivo',
  'vip.setup.pointConfig.maxLessThanMin': 'Los puntos máximos no pueden ser menores que los mínimos',
  'vip.setup.pointConfig.probabilityInvalid': 'La probabilidad debe ser un número entre 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'La probabilidad total debe ser igual a 100%, actualmente {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'La probabilidad total debe ser igual a 100%',
  'vip.setup.pointConfig.setting': 'Configuración',
  'vip.setup.pointConfig.totalProbability': 'Probabilidad Total',
  'vip.setup.pointConfig.action': 'Acción',
  'vip.setup.pointConfig.count': 'Cantidad',
  'vip.setup.pointConfig.title': 'Configuración de Puntos',
  'vip.setup.pointConfig.minPoint': 'Puntos Mín.',
  'vip.setup.pointConfig.maxPoint': 'Puntos Máx.',
  'vip.setup.pointConfig.probability': 'Probabilidad',
  'vip.setup.pointConfig.add': 'Añadir',
  'vip.setup.pointConfig.delete': 'Eliminar',
  'vip.setup.pointConfig.save': 'Confirmar',
  'vip.setup.pointConfig.cancel': 'Cancelar',
  'vip.setup.pointConfig.minPointRequired': 'Ingrese los puntos mínimos',
  'vip.setup.pointConfig.maxPointRequired': 'Ingrese los puntos máximos',
  'vip.setup.pointConfig.probabilityRequired': 'Ingrese la probabilidad',
  'vip.setup.pointConfig.minPointInvalid': 'Los puntos mínimos deben ser un entero positivo',
  'vip.setup.pointConfig.maxPointInvalid': 'Los puntos máximos deben ser un entero positivo',
  'vip.setup.pointConfig.maxLessThanMin': 'Los puntos máximos no pueden ser menores que los mínimos',
  'vip.setup.pointConfig.probabilityInvalid': 'La probabilidad debe ser un número entre 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'La probabilidad total debe ser igual a 100%, actualmente {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'La probabilidad total debe ser igual a 100%',
  'vip.setup.pointConfig.setting': 'Configuración',
  'vip.setup.pointConfig.totalProbability': 'Probabilidad Total',
  'vip.setup.pointConfig.action': 'Acción',


  // VIP Unified Reward Configuration
  'vip.unified.scene.upgrade': 'Recompensa de Ascenso',
  'vip.unified.scene.retention': 'Recompensa de Retención',
  'vip.unified.scene.weekly': 'Salario Semanal',
  'vip.unified.scene.monthly': 'Salario Mensual',
  'vip.unified.scene.birthday': 'Recompensa de Cumpleaños',
  'vip.unified.scene.appDaily': 'Diario de App',
  'vip.unified.scene.h5Daily': 'Diario H5',
  'vip.unified.basicReward': 'Recompensas Básicas',
  'vip.unified.claimConditions': 'Condiciones de Reclamo',
  'vip.unified.rewardCurrency': 'Moneda de Recompensa',
  'vip.unified.reward': 'Recompensa',
  'vip.unified.point': 'Puntos',
  'vip.unified.ticket': 'Ticket',
  'vip.unified.flowMultiple': 'Múltiple de Apuestas',
  'vip.unified.requiresDeposit': 'Depósito Requerido',
  'vip.unified.requiresBetflow': 'Apuestas Requeridas',
  'vip.unified.verifyMobile': 'Verificación Móvil',
  'vip.unified.pointConfig': 'Configuración de Puntos',
  'vip.unified.claimValidityDays': 'Días de Validez del Reclamo',
  'vip.unified.enterReward': 'Ingrese la recompensa',
  'vip.unified.enterPoint': 'Ingrese los puntos',
  'vip.unified.enterFlowMultiple': 'Ingrese el múltiple de apuestas',
  'vip.unified.enterRequiresDeposit': 'Ingrese el depósito requerido',
  'vip.unified.enterRequiresBetflow': 'Ingrese las apuestas requeridas',
  'vip.unified.enterClaimValidityDays': 'Ingrese los días de validez',
  'vip.unified.selectTicket': 'Seleccione el ticket',
  'vip.unified.enterQuantity': 'Ingrese la cantidad',
  'vip.unified.quantity': 'Cantidad',

  // VIP Manual Adjustment
  'vip.adjust.title': 'Ajuste Manual VIP',
  'vip.adjust.singleTab': 'Ajuste Individual',
  'vip.adjust.batchTab': 'Ajuste por Lote',
  'vip.adjust.memberAccount': 'Cuenta de Miembro',
  'vip.adjust.enterMemberAccount': 'Ingrese la cuenta de miembro y presione Enter para buscar',
  'vip.adjust.enterMemberAccountRequired': 'Ingrese la cuenta de miembro',
  'vip.adjust.query': 'Buscar',
  'vip.adjust.account': 'Cuenta',
  'vip.adjust.currentVip': 'VIP Actual',
  'vip.adjust.growthValue': 'Valor de Crecimiento',
  'vip.adjust.toNextLevel': 'Falta para Siguiente Nivel',
  'vip.adjust.maxLevel': 'Nivel Máximo',
  'vip.adjust.adjustType': 'Tipo de Ajuste',
  'vip.adjust.adjustGrow': 'Ajustar Valor de Crecimiento',
  'vip.adjust.adjustGrowDesc': 'Aumentar o disminuir valor de experiencia',
  'vip.adjust.adjustLevel': 'Ajustar Nivel VIP',
  'vip.adjust.adjustLevelDesc': 'Cambiar directamente el nivel VIP',
  'vip.adjust.direction': 'Dirección',
  'vip.adjust.increase': 'Aumentar(+)',
  'vip.adjust.decrease': 'Disminuir(-)',
  'vip.adjust.adjustValueLabel': 'Valor de Ajuste',
  'vip.adjust.positiveInteger': 'Entero positivo',
  'vip.adjust.enterAdjustValue': 'Ingrese el valor de crecimiento a ajustar',
  'vip.adjust.exceedCurrentGrow': 'La deducción no puede exceder el valor de crecimiento actual ({{value}})',
  'vip.adjust.targetLevel': 'Nivel VIP Objetivo',
  'vip.adjust.selectTargetLevel': 'Seleccione el nivel objetivo',
  'vip.adjust.currentLevelTag': 'Nivel Actual',
  'vip.adjust.targetLevelSame': 'El nivel objetivo es igual al nivel actual',
  'vip.adjust.levelThresholdInfo': 'Valor de crecimiento inicial de VIP{{level}}: {{threshold}}, el valor de crecimiento se establecerá en {{threshold}}',
  'vip.adjust.remark': 'Observación',
  'vip.adjust.remarkOptional': 'Opcional, máx. 200 caracteres',
  'vip.adjust.remarkPlaceholder': 'ej. Compensación por actividad, compensación por error del sistema, deducción de control de riesgo, etc.',
  'vip.adjust.changePreview': 'Vista Previa del Cambio',
  'vip.adjust.upgradeLabel': ' (Ascenso)',
  'vip.adjust.downgradeLabel': ' (Descenso)',
  'vip.adjust.upgradeImpact': 'Impacto de Ascenso (los cambios tomarán efecto inmediatamente o por ciclo)',
  'vip.adjust.downgradeImpact': 'Impacto de Descenso (los cambios tomarán efecto inmediatamente o por ciclo)',
  'vip.adjust.confirmTitle': '¿Confirmar Ajuste?',
  'vip.adjust.confirmOk': 'Confirmar',
  'vip.adjust.cancel': 'Cancelar',
  'vip.adjust.confirmExec': 'A punto de ejecutarse en el miembro {{account}}:',
  'vip.adjust.confirmWarning': 'Esta operación tiene efecto inmediato y los registros no se pueden eliminar.',
  'vip.adjust.submitSuccess': 'Ajuste exitoso, datos VIP actualizados para {{account}}',
  'vip.adjust.submitFailed': 'Falló el ajuste, reinténtelo',
  'vip.adjust.requestFailed': 'Falló la solicitud, reinténtelo',
  'vip.adjust.memberNotFound': 'Miembro no encontrado, verifique la cuenta',
  'vip.adjust.queryFailed': 'Falló la búsqueda, reinténtelo',
  'vip.adjust.lookupFirst': 'Primero busque la cuenta de miembro',
  'vip.adjust.enterValue': 'Ingrese el valor de ajuste',
  'vip.adjust.confirmBtn': 'Confirmar Ajuste',
  'vip.adjust.close': 'Cerrar',
  'vip.adjust.manualAdjust': 'Ajuste Manual',
  'vip.adjust.system': 'Sistema',
  'vip.adjust.impact.upgradeReward': 'Recompensa de Ascenso: Activar recompensa VIP{{level}} (niveles reclamados no se reinician)',
  'vip.adjust.impact.withdrawLimit': 'Límite de Retiro VIP: Cambio inmediato al límite VIP{{level}}',
  'vip.adjust.impact.retentionProtection': 'Período de Retención: Recalculado desde hoy',
  'vip.adjust.impact.pointMall': 'Centro de Puntos/Rueda de la Suerte: Desbloquear cualificación VIP{{level}}',
  'vip.adjust.impact.customerService': 'Enrutamiento de Servicio al Cliente: Siguiente chat enrutado por VIP{{level}}',
  'vip.adjust.impact.notification': 'Mensaje en Aplicación: Enviar notificación de ascenso',
  'vip.adjust.impact.noRecovery': 'Recompensas/puntos otorgados no se recuperan, futuro sigue estándar VIP{{level}}',
  'vip.adjust.impact.withdrawLimitDown': 'Límite de Retiro VIP: Reducción inmediata al límite VIP{{level}}',
  'vip.adjust.impact.loseQualification': 'Centro de Puntos/Rueda de la Suerte: Perder cualificaciones que exceden VIP{{level}}',
  'vip.adjust.impact.noNotification': 'Mensaje en Aplicación: Sin notificación enviada',
  'vip.adjust.uploadFile': 'Primero cargue un archivo',
  'vip.adjust.batchTaskCreated': 'Tarea por lote creada, ID de Tarea: {{taskId}}',
  'vip.adjust.uploadFailed': 'Falló el procesamiento de carga',
  'vip.adjust.uploadError': 'Falló la carga, reinténtelo',
  'vip.adjust.templateDownloading': 'Descargando plantilla...',
  'vip.adjust.templateDownloadFailed': 'Falló la descarga de plantilla',
  'vip.adjust.downloadTemplate': 'Descargar Plantilla de Importación',
  'vip.adjust.templateGuide': 'Instrucciones de Plantilla',
  'vip.adjust.colName': 'Columna',
  'vip.adjust.colRequired': 'Requerido',
  'vip.adjust.colDesc': 'Descripción',
  'vip.adjust.colExample': 'Ejemplo',
  'vip.adjust.colMemberAccountDesc': 'Mismo que la lista de miembros del backend',
  'vip.adjust.colAdjustTypeDesc': '1=Ajustar Valor de Crecimiento, 2=Ajustar Nivel VIP',
  'vip.adjust.colAdjustTypeExample': '1',
  'vip.adjust.colDirectionRequired': 'Requerido al ajustar valor de crecimiento',
  'vip.adjust.colDirectionDesc': '1=Aumentar, 2=Disminuir; dejar vacío para nivel',
  'vip.adjust.colDirectionExample': '1',
  'vip.adjust.colValueDesc': 'Valor de crecimiento=entero positivo; Nivel=nivel objetivo(0~30)',
  'vip.adjust.colRemarkRequired': 'No',
  'vip.adjust.colRemarkDesc': '≤200 caracteres, usa observación por lote si está vacío',
  'vip.adjust.colRemarkExample': 'Compensación por actividad',
  'vip.adjust.uploadDragText': 'Haga clic o arrastre para cargar archivo CSV',
  'vip.adjust.uploadHint': 'Máx. 5000 registros por lote, archivo ≤ 20MB',
  'vip.adjust.fileSizeLimit': 'El tamaño del archivo no puede exceder 20MB',
  'vip.adjust.batchRemark': 'Observación por Lote',
  'vip.adjust.batchRemarkOptional': 'Opcional, compartido para este lote',
  'vip.adjust.batchRemarkPlaceholder': 'ej. Compensación de valor de crecimiento de actividad de marzo',
  'vip.adjust.batchCreatedTitle': 'Tarea de ajuste por lote creada',
  'vip.adjust.batchCheckProgress': 'La tarea se ejecutará de forma asincrónica, verifique el progreso en la pestaña "Tareas por Lote"',
  'vip.adjust.confirmBatch': 'Confirmar Ajuste por Lote',
  'vip.adjust.yes': 'Sí',

  // VIP Batch Tasks
  'vip.batch.title': 'Tareas por Lote',
  'vip.batch.taskId': 'ID de Tarea',
  'vip.batch.fileName': 'Nombre de Archivo',
  'vip.batch.totalCount': 'Total',
  'vip.batch.success': 'Exitoso',
  'vip.batch.fail': 'Fallido',
  'vip.batch.status': 'Estado',
  'vip.batch.batchRemark': 'Observación por Lote',
  'vip.batch.operator': 'Operador',
  'vip.batch.createTime': 'Fecha de Creación',
  'vip.batch.completeTime': 'Fecha de Finalización',
  'vip.batch.action': 'Acción',
  'vip.batch.pending': 'Pendiente',
  'vip.batch.processing': 'Procesando',
  'vip.batch.completed': 'Completado',
  'vip.batch.failed': 'Falló',
  'vip.batch.unknown': 'Desconocido',
  'vip.batch.refresh': 'Actualizar',
  'vip.batch.failDetail': 'Detalles de Fallo',
  'vip.batch.refreshList': 'Actualizar Lista',
  'vip.batch.fetchFailed': 'Falló obtener lista de tareas',
  'vip.batch.statusRefreshed': 'Estado actualizado',
  'vip.batch.refreshFailed': 'Falló la actualización',
  'vip.batch.noFailDetail': 'Sin detalles de fallo para exportar',
  'vip.batch.exportSuccess': 'Exportación exitosa',
  'vip.batch.exportFailed': 'Falló la exportación',

  // Límite diario de retiro por jugador (FBMPLAY-1704)
  'vip.memberLimit.buttonTitle': 'Límite de Retiro',
  'vip.memberLimit.modalTitle': 'Configurar Límite Diario de Retiro',
  'vip.memberLimit.currency': 'Moneda',
  'vip.memberLimit.mode': 'Límite Diario de Retiro · Modo',
  'vip.memberLimit.modeVip': 'Según límite diario del nivel VIP (predeterminado)',
  'vip.memberLimit.modeMember': 'Según límite diario exclusivo del jugador',
  'vip.memberLimit.amount': 'Límite Diario Exclusivo (/ día)',
  'vip.memberLimit.amountHint': 'Puede ser mayor o menor que el VIP predeterminado; -1 = sin límite; no se permite 0',
  'vip.memberLimit.diff': '{sign}{diff} frente al predeterminado VIP{level}',
  'vip.memberLimit.diffSame': 'Igual que el predeterminado VIP{level}',
  'vip.memberLimit.diffVipUnlimited': 'El predeterminado VIP{level} es sin límite',
  'vip.memberLimit.amountInvalid': 'Ingrese -1 o un monto mayor que 0',
  'vip.memberLimit.enterAmount': 'Ingrese el límite diario exclusivo',
  'vip.memberLimit.unlimited': 'Sin límite',
  'vip.memberLimit.unlimitedCell': 'Sin límite (-1)',
  'vip.memberLimit.perDay': 'día',
  'vip.memberLimit.remark': 'Observación',
  'vip.memberLimit.enterRemark': 'Indique el motivo de este ajuste',
  'vip.memberLimit.effectHint': 'Efecto inmediato; lo retirado hoy no cambia, la cuota restante se recalcula',
  'vip.memberLimit.saveSuccess': 'Guardado',
  'vip.memberLimit.saveFailed': 'Error al guardar',
  'vip.memberLimit.memberAccount': 'Cuenta de Miembro',
  'vip.memberLimit.enterMemberAccount': 'Ingrese la cuenta de miembro',
  'vip.memberLimit.statusActive': 'Activo',
  'vip.memberLimit.statusDisabled': 'Desactivado',
  'vip.memberLimit.operator': 'Operador',
  'vip.memberLimit.enterOperator': 'Ingrese el operador',
  'vip.memberLimit.operateTime': 'Hora de Operación',
  'vip.memberLimit.edit': 'Editar',
};
